var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"chip",attrs:{"color":_vm.findType().color}},[_vm._v(_vm._s(_vm.findType().description))])}
var staticRenderFns = []

export { render, staticRenderFns }